import React, { useState, useEffect } from 'react';
import './Navbar.css';

const Navbar = ({ currentLanguage, onLanguageChange, theme, onThemeToggle, openModal }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 100);
    };

    const handleResize = () => {
      if (window.innerWidth > 1150 && isMobileMenuOpen) {
        setIsMobileMenuOpen(false);
        document.body.style.overflow = 'unset';
      }
    };

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleResize);
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleResize);
    };
  }, [isMobileMenuOpen]);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const navbarHeight = 80;
      const targetPosition = element.offsetTop - navbarHeight - 20;
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });
    }
    setIsMobileMenuOpen(false);
    document.body.style.overflow = 'unset';
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
    // Prevent body scroll when menu is open
    if (!isMobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
  };

  const handleDropdownToggle = (dropdown) => {
    if (window.innerWidth <= 768) {
      setActiveDropdown(activeDropdown === dropdown ? null : dropdown);
    }
  };

  const handleServiceInquiry = () => {
    openModal({
      type: 'inquiry',
      title: 'Service Inquiry',
      content: 'Please call us for more information about this service.'
    });
    setIsMobileMenuOpen(false);
  };

  const handleProductSoon = () => {
    openModal({
      type: 'product',
      title: 'Coming Soon!',
      content: 'Our product section is under development. Please check back later for exciting offerings!'
    });
    setIsMobileMenuOpen(false);
  };

  const getTranslation = (key) => {
    const translations = {
      home: 'Home',
      about: 'About',
      vastu: 'Vastu',
      numerology: 'Numerology',
      astrology: 'Astrology',
       presidentialEvent: 'Presidential Event',
      events: 'Events',
     
      certification: 'Certification',
      news: 'News',
      gallery: 'Gallery',
      contact: 'Contact'
    };
    return translations[key];
  };

  return (
    <nav className={`navbar ${isScrolled ? 'scrolled' : ''}`} id="navbar">
      <div className="nav-container">
        <div className="nav-logo">
          <button onClick={() => scrollToSection('home')} className="logo-btn">
            <img src="/images/logo.jpeg" alt="Mystic Astrologer Logo" className="logo-image" />
            <div className="nav-names">
              <span className="main-name">Astrovastukstar</span>
              <span className="sub-name">Kstarplanetary</span>
            </div>
          </button>
        </div>

        <ul className={`nav-menu ${isMobileMenuOpen ? 'active' : ''}`} id="nav-menu">
          <li><button onClick={() => scrollToSection('home')} className="nav-link">{getTranslation('home')}</button></li>
          <li><button onClick={() => scrollToSection('about')} className="nav-link">{getTranslation('about')}</button></li>
          
          {/* Main Services */}
          <li><button onClick={() => scrollToSection('services')} className="nav-link service-link vastu-link">
            <i className="fas fa-home"></i> {getTranslation('vastu')}
          </button></li>
          <li><button onClick={() => scrollToSection('services')} className="nav-link service-link numerology-link">
            <i className="fas fa-calculator"></i> {getTranslation('numerology')}
          </button></li>
          <li><button onClick={() => scrollToSection('services')} className="nav-link service-link astrology-link">
            <i className="fas fa-star"></i> {getTranslation('astrology')}
          </button></li>
          
          <li><button onClick={() => scrollToSection('special-event')} className="nav-link">{getTranslation('presidentialEvent')}</button></li>
          <li><button onClick={() => scrollToSection('events')} className="nav-link">{getTranslation('events')}</button></li>
          <li><button onClick={() => scrollToSection('certification')} className="nav-link">{getTranslation('certification')}</button></li>
          <li><button onClick={() => scrollToSection('news')} className="nav-link">{getTranslation('news')}</button></li>
          <li><button onClick={() => scrollToSection('gallery')} className="nav-link">{getTranslation('gallery')}</button></li>
          <li><button onClick={() => scrollToSection('contact')} className="nav-link">{getTranslation('contact')}</button></li>
        </ul>

        <div className="nav-controls">
          <div className="theme-toggle">
            <button onClick={onThemeToggle} className="theme-toggle-btn" title="Toggle Theme">
              <i className={`fas ${theme === 'dark' ? 'fa-sun' : 'fa-moon'}`}></i>
            </button>
          </div>
        </div>

        <div className={`hamburger ${isMobileMenuOpen ? 'active' : ''}`} onClick={toggleMobileMenu}>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;